import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  EditTwoTone,
} from '@ant-design/icons'
import { Input, notification, Spin } from 'antd'
import { useState } from 'react'
import { useReAssignDocument } from '~app/graph/document'
import { ReassignDocumentStage } from '~app/graph/generated/graphql'
import i18n from '~app/i18n/i18n'

interface Props {
  customerPublicId: string
  documentId: string
}

const PublicIdInput = ({ customerPublicId, documentId }: Props) => {
  const [isEditingPublicId, setIsEditingPublicId] = useState<boolean>(false)
  const [editedPublicId, setEditedPublicId] = useState<string | undefined>()
  const [reassignDocument, { loading }] = useReAssignDocument()

  const save = async () => {
    setIsEditingPublicId(false)
    if (editedPublicId === customerPublicId || editedPublicId === '') {
      return
    }
    try {
      const result = await reassignDocument({
        variables: {
          documentId,
          data: {
            encodedPublicId: editedPublicId,
            stage: ReassignDocumentStage.ManualProcessingStarted,
          },
        },
      })
      if (result && result.error) {
        const error = result.error
        notification.error({
          message: i18n.t('deleteDocuments.errorReassigingDocument'),
          description: error.message,
        })
      } else {
        notification.success({
          message: i18n.t('misc.success'),
          description: i18n.t(
            'deleteDocuments.documentReassignedSuccessfully',
            { documentId }
          ),
        })
      }
    } catch (error) {
      notification.error({
        message: i18n.t('deleteDocuments.errorReassigingDocument'),
        description:
          (error as any).message || i18n.t('deleteDocuments.errorMessageFatal'),
      })
    }
    setEditedPublicId(undefined)
  }

  return !isEditingPublicId && !loading ? (
    <>
      <p style={{ fontSize: 14 }}>{customerPublicId}</p>
      <EditTwoTone
        onClick={() => {
          setIsEditingPublicId(true)
          setEditedPublicId(customerPublicId)
        }}
      />
    </>
  ) : (
    <>
      <Input
        value={editedPublicId}
        onChange={e => {
          setEditedPublicId(e.target.value)
        }}
        autoFocus
        onFocus={e => e.target.select()}
        onPressEnter={() => save()}
        defaultValue={customerPublicId}
        disabled={loading}
      />
      {loading ? (
        <Spin style={{ marginLeft: '10px' }} />
      ) : (
        <>
          <CheckCircleTwoTone onClick={() => save()} />
          <CloseCircleTwoTone
            onClick={() => setIsEditingPublicId(false)}
            twoToneColor="#f44336"
          />
        </>
      )}
    </>
  )
}

export default PublicIdInput
